import { RegionalOption } from 'owa-regional-option';
import { OptionSubCategory } from 'owa-options-core';

let accountSubCategory: OptionSubCategory = {
    key: 'timeAndLanguage',
    titleStringKey: 'optionSubcategory_account',
    options: [RegionalOption],
};

export default accountSubCategory;
